<div
    data-cy="share-button"
    class="button share-button"
    (click)="onShareClick($event)"
    *ngIf="shouldShowShareButton()"
>
    {{ "forms.channel.alarm.button.share" | translate }}
</div>
<div
    data-cy="edit-button"
    class="button edit"
    (click)="onEditClick($event)"
    *ngIf="shouldShowEditButton()"
>
    <mat-icon class="icon" svgIcon="blue-pencil"></mat-icon>
    {{ "forms.channel.alarm.button.edit" | translate }}
</div>
<div
    data-cy="delete-button"
    class="button"
    (click)="onDeleteClick($event)"
    *ngIf="shouldShowDeleteButton()"
>
    <mat-icon class="icon delete-icon" svgIcon="delete"></mat-icon>
    {{ "forms.channel.alarm.button.delete" | translate }}
</div>
